<div class="empty" *ngIf="isVisible">

  <img *ngIf="showImage" [src]="imgUrl" />

  <span [@fadeAnimation]="'in'">{{ title }}</span>

  <span>{{ subTitle }}</span>

</div>